import React from 'react';

import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../../common/Loading';

import getMedidas from '../../../../graphql/querys/otros/getMedidas.graphql';
import deleteMedida from '../../../../graphql/mutations/otros/deleteMedida.graphql';

import TablaMedidas from './TablaMedidas';
import { errorService } from '../../../../graphql/utils/utils';

const confirm = Modal.confirm;

@compose(
  graphql(getMedidas, { options: { fetchPolicy: 'network-only' } }),
  graphql(deleteMedida, {
    name: 'deleteMedida',
    options: {
      refetchQueries: [{ query: getMedidas }],
    },
  })
)
class VerMedidas extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };

    this.onDelete = this.onDelete.bind(this);
  }

  onDelete(id) {
    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar esta medida?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteMedida({
            variables: { _id: id },
          })
          .then(res => {
            notification.success({
              message: 'Medida eliminada',
              description: 'Se ha eliminado correctamente la medida',
            });
          })
          .catch(err => {
            console.log('Existio un error a la hora de eliminar la medida');
            console.log(err);
            errorService(err, { _id: id });
            Modal.error({
              title: 'Error en la eliminacion de la medida',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    let listaMedidas = this.props.data.getMedidas;

    if (!listaMedidas) {
      listaMedidas = [];
    }

    return (
      <div>
        <TablaMedidas
          medidas={listaMedidas}
          history={this.props.history}
          onDelete={this.onDelete}
        />
      </div>
    );
  }
}

export default withApollo(VerMedidas);
